import emailViewSummaryMapper from "@/mappers/emailViewSummaryMapper";
import { useFavoriteViewsSummary } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMemo } from "react";
import useLiveErrorNotifier from "./utils/useLiveErrorNotifier";

const useGetDashboardData = () => {
    const { data, isLoading: loading, error } = useFavoriteViewsSummary();

    useLiveErrorNotifier(error, {
        titleTranslationKey: "errors.dashboardSummary",
    });

    const emailViewList = useMemo(
        () => (data ?? []).map(emailViewSummaryMapper),
        [data],
    );

    return { emailViewList, loading };
};

export default useGetDashboardData;
